import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Positioned context menu with viewport-aware placement.
 *
 * Renders a dropdown menu at the specified screen position,
 * adjusting to prevent viewport overflow. Dismisses on Escape
 * or click outside.
 */
import { useCallback, useEffect, useState, useRef } from 'react';
export function ContextMenu({ x, y, actions, onClose, }) {
    const menuRef = useRef(null);
    const [adjustedPosition, setAdjustedPosition] = useState({ x, y });
    // Adjust position if menu would overflow viewport
    useEffect(() => {
        if (menuRef.current) {
            const rect = menuRef.current.getBoundingClientRect();
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;
            let adjustedX = x;
            let adjustedY = y;
            if (x + rect.width > viewportWidth - 10) {
                adjustedX = viewportWidth - rect.width - 10;
            }
            if (y + rect.height > viewportHeight - 10) {
                adjustedY = viewportHeight - rect.height - 10;
            }
            setAdjustedPosition({ x: adjustedX, y: adjustedY });
        }
    }, [x, y]);
    // Close on click outside or Escape
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                onClose();
            }
        };
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
        };
    }, [onClose]);
    const handleAction = useCallback((action) => {
        if (!action.disabled) {
            action.onClick();
            onClose();
        }
    }, [onClose]);
    return (_jsx("div", { ref: menuRef, className: "ac-context-menu", style: {
            left: adjustedPosition.x,
            top: adjustedPosition.y,
        }, role: "menu", children: actions.map((action, index) => {
            if (action.separator) {
                return (_jsx("div", { className: "ac-context-menu-separator" }, `separator-${index}`));
            }
            const className = action.disabled
                ? 'ac-context-menu-item ac-context-menu-item--disabled'
                : action.danger
                    ? 'ac-context-menu-item ac-context-menu-item--danger'
                    : 'ac-context-menu-item';
            return (_jsxs("button", { className: className, onClick: () => handleAction(action), disabled: action.disabled, role: "menuitem", children: [action.icon && _jsx("span", { className: "ac-context-menu-icon", children: action.icon }), action.label] }, action.label));
        }) }));
}
//# sourceMappingURL=ContextMenu.js.map